import React, { useState } from "react";
import { Helmet } from "react-helmet";

import LinkRedirect from "../../../common/LinkRedirect";
import NewModal from "../../../NewModal";
import BodyModalChat from "../../../NewModal/BodyModalChat";

import {
  ContactContainer,
  FooterGrid,
  FooterItem,
  FooterItemDescription,
  FooterItemLink,
  FooterHeader,
  FooterTitle,
  Divider,
  ReclameAquiStamps,
  AboutContainer,
  AboutLink,
  NavLinkAbout,
  AboutDescription,
  AboutDescriptionContainer,
} from "./Footer.style";

import { ReactComponent as IconChat } from "../../../../assets/images/habitacional/icon-chat.svg";
import { ReactComponent as IconSac } from "../../../../assets/images/habitacional/icon-sac.svg";
import { ReactComponent as IconCentral } from "../../../../assets/images/habitacional/icon-central.svg";
import { ReactComponent as IconOuvidoria } from "../../../../assets/images/habitacional/icon-ouvidoria.svg";
import { ReactComponent as IconSurdo } from "../../../../assets/images/habitacional/icon-surdo.svg";
import { ReactComponent as Logo } from "../../../../assets/images/csh-logo-bg-neutral.svg";
import { ReactComponent as IconChatConversation } from "../../../../assets/images/icons/chat-icon.svg";

import { chatButtons } from "../../../../config";

export const Item = ({
  icon,
  title,
  link,
  linkText,
  description,
  onClick,
  noFooter,
}) => {
  return (
    <FooterItem noFooter={noFooter}>
      <FooterHeader>
        {icon}
        <div>
          <FooterItemDescription>{title}</FooterItemDescription>
          <FooterItemLink href={link !== "Chat" ? link : "#"} onClick={onClick}>
            {linkText}
          </FooterItemLink>
        </div>
      </FooterHeader>
      <FooterItemDescription>{description}</FooterItemDescription>
    </FooterItem>
  );
};

const FooterHabitacional = () => {
  const [isOpenModalChat, setIsOpenModalChat] = useState(false);
  const [activeItem, setActiveItem] = useState(null);

  const footerItens = [
    {
      id: 1,
      title: "Chat",
      link: "Chat",
      linkText: "Falar com um atendente",
      description:
        "Converse com um de nossos atendentes, tire suas dúvidas ou consulte outros serviços.",
      icon: <IconChat height={48} />,
      onClick: (event) => {
        event.preventDefault();
        setIsOpenModalChat((state) => !state);
      },
    },
    {
      id: 2,
      title: "Serviços, assistência e sinistro",
      link: "tel:0800 274 1000",
      linkText: "0800 274 1000",
      description:
        "Assistências: 24h, todos os dias da semana. Sinistro: das 8h às 19h, de segunda a sexta, exceto em feriados nacionais. " +
        "Demais serviços: das 8h às 21h, de segunda a sexta, exceto em feriados nacionais.",
      icon: <IconCentral />,
    },
    {
      id: 3,
      title: "SAC 24h, todos os dias",
      link: "tel:0800 274 2000",
      linkText: "0800 274 2000",
      description: (
        <>
          Informações, dúvidas, sugestões, reclamações e cancelamentos. Das 21h
          às 8h, converse com a gente apenas pelo{" "}
          <a
            target="_blank"
            href="https://wa.me/+5508002742000"
            rel="noreferrer"
          >
            WhatsApp
          </a>{" "}
          no mesmo número.
        </>
      ),
      icon: <IconSac />,
    },
    {
      id: 4,
      title: "Atendimento ao surdo 24h",
      link: "",
      linkText: "Clique para ser atendido",
      description:
        "Você será redirecionado para o site do ICOM, parceiro da Caixa Seguradora, para receber atendimento em LIBRAS.",
      icon: <IconSurdo />,
      onClick: (e) => {
        e.preventDefault?.();
        document.getElementById("accessibility-button").click();
      },
    },
    {
      id: 5,
      title: "Ouvidoria",
      link: "tel:0800 274 3000",
      linkText: "0800 274 3000",
      description: (
        <>
          De seg a sex, das 8h às 18h, exceto em feriados nacionais. Se
          preferir, você pode abrir uma{" "}
          <a
            href="https://www.cshbrasil.com.br/ouvidoria"
            target="_blank"
            rel="noopener noreferrer"
          >
            ocorrência online
          </a>
          .
        </>
      ),
      icon: <IconOuvidoria />,
    },
  ];

  return (
    <>
      <footer>
        <ContactContainer>
          <FooterTitle>Fale com a Caixa Seguradora</FooterTitle>
          <Divider />
          <FooterGrid>
            {footerItens.map((item) => {
              return (
                <Item
                  key={item.id}
                  title={item.title}
                  description={item.description}
                  link={item.link}
                  linkText={item.linkText}
                  icon={item.icon}
                  onClick={item?.onClick}
                />
              );
            })}
          </FooterGrid>
          <ReclameAquiStamps>
            <div id="reputation-ra">
              <Helmet>
                <script
                  type="text/javascript"
                  id="ra-embed-reputation"
                  src="https://s3.amazonaws.com/raichu-beta/selos/bundle.js"
                  data-id="MTg4NzpjYWl4YS1zZWd1cmFkb3Jh"
                  data-target="reputation-ra"
                  data-model="2"
                />
              </Helmet>
            </div>
            <div id="ra-verified-seal">
              <Helmet>
                <script
                  type="text/javascript"
                  id="ra-embed-verified-seal"
                  src="https://s3.amazonaws.com/raichu-beta/ra-verified/bundle.js"
                  data-id="MTg4NzpjYWl4YS1zZWd1cmFkb3Jh"
                  data-target="ra-verified-seal"
                  data-model="1"
                />
              </Helmet>
            </div>
          </ReclameAquiStamps>
        </ContactContainer>
        <AboutContainer>
          <Logo />
          <NavLinkAbout>
            <AboutLink href="/">Caixa Seguradora</AboutLink>
            <AboutLink
              href="https://portal.caixaseguradora.com.br/Sobre-a-empresa/Paginas/Seguranca.aspx"
              target="_blank"
            >
              Segurança
            </AboutLink>
            <LinkRedirect
              as={AboutLink}
              href="https://csh.my.site.com/portalprivacidade/s/"
              target="_blank"
            >
              Política de privacidade
            </LinkRedirect>
            <AboutLink>Cookies</AboutLink>
            <AboutLink
              href="https://www.contatoseguro.com.br/cshbrasil"
              target="_blank"
            >
              Canal de ética
            </AboutLink>
          </NavLinkAbout>
          <Divider />
          <AboutDescriptionContainer>
            <AboutDescription>
              Caixa Seguradora S/A - CNPJ 34.020.354/0001-10 <br />
              Edifício Sede: SHN Quadra 01, Conjunto A, Bloco E <br />
              Brasília/DF - CEP: 70.701-050 <br />
            </AboutDescription>
            <AboutDescription>
              © Copyright 2024 Caixa Seguradora
            </AboutDescription>
          </AboutDescriptionContainer>
        </AboutContainer>
      </footer>

      {/* Chat modal */}
      <NewModal
        show={isOpenModalChat}
        onToggle={setIsOpenModalChat}
        closeHandle={isOpenModalChat}
        titleModal="Chat"
        subTitleModal="Escolha sobre qual seguro quer falar."
        icon={<IconChatConversation />}
      >
        <BodyModalChat
          itemChat={chatButtons}
          showModal={isOpenModalChat}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
      </NewModal>
    </>
  );
};

export default FooterHabitacional;
